import styled from 'styled-components';

export const FormContainer = styled.div`
  margin: 0 1rem 1rem 1rem;
`;

export const CopyWrapper = styled.button`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  padding-right: 24px;
  font-size: 12px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.colors.primary};
  letter-spacing: 1px;
  cursor: pointer;
  outline: none;
  border: none;
  background-color: transparent;
`;
